module.exports = flarum.core.compat['utils/UserControls'];